const KEY_NAME = 'leadGenBlocked';
const MINIMIZED_KEY_NAME = 'minimizedLeadGenBlocked';

const DAYS_TO_BLOCK_IF_CLOSED = 1;
const DAYS_TO_BLOCK_AFTER_SIGNUP = 30;

const nDaysFromNow = (n: number) => {
    const result = new Date();
    result.setDate(result.getDate() + n);
    return result;
};

interface ExpirationEntry {
    expiration: Date,
}
type EntryValue = null | undefined | ExpirationEntry

const setExpirationDate = (numberDays: number, useMinimizedField: boolean) => {
    const expiration = nDaysFromNow(numberDays);
    const key = useMinimizedField ? MINIMIZED_KEY_NAME : KEY_NAME;

    // Don't save an expiration-date sooner than the one we already have saved.
    window.dcLocalStorage.requestCrossDomainValue(key, (key, value: EntryValue) => {
        const isBadValue = !value || !value.expiration;
        if (isBadValue || value.expiration < expiration) {
            window.dcLocalStorage.setCrossDomainValue(key, { expiration });
        }
    });
};

// Uncomment this as needed for additional local debugging.
// window.getLeadGenBlockExpiration = () => {
//     window.dcLocalStorage.requestCrossDomainValue('leadGenBlocked', console.log);
// };

/**
 * Check localStorage to see if we can/should show the "lead gen" form for the current user.
 *
 * @param onSuccess Will be called if localStorage tells us to go ahead. Probably just gonna be a Promise-resolve!
 * @param useMinimizedField If true, check localStorage[MINIMIZED_KEY_NAME] instead of localStorage[KEY_NAME].
 */
export const localStorageChecks = (onSuccess: () => void, useMinimizedField: boolean) => {
    const keyName = useMinimizedField ? MINIMIZED_KEY_NAME : KEY_NAME;

    window.dcLocalStorage.requestCrossDomainValue(keyName, (_key, value: EntryValue) => {
        // Continue if no block is recorded, or if block has expired
        if (value?.expiration == null || value.expiration < new Date()) {
            onSuccess();
        }

        // Do nothing otherwise
    });
};

export const onClose = (minimizedLeadGenEnabled: boolean) => {
    if (!minimizedLeadGenEnabled) {
        setExpirationDate(DAYS_TO_BLOCK_IF_CLOSED, false);
    }
};
export const onSignup = () => {
    setExpirationDate(DAYS_TO_BLOCK_AFTER_SIGNUP, true);
    setExpirationDate(DAYS_TO_BLOCK_AFTER_SIGNUP, false);
};
